module.exports = __webpack_public_path__ + "assets/img/tx111_3.e3505f69.jpg";